import { useContext } from 'react';
import { ProductionTemporalChartsDataContext } from '../contexts/ProductionTemporalChartsDataContext';

export const useProductionTemporalChartsDataContext = () => {
    return useContext(ProductionTemporalChartsDataContext);
};
